import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpHandler, HttpRequest } from "@angular/common/http";
import { environment } from "@apps/patient-core/src/app/environments/environment";
import { EMPTY, switchMap } from "rxjs";
import { BaseAuthService } from "../services/abstracts/auth.service";
import { API_PATH_PREFIX as AUTH_API_PATH_PREFIX } from "@dentally/auth/auth-constants";

const { HOST_ZONE } = environment;

@Injectable({
  providedIn: "root",
})
export class AuthInterceptor implements HttpInterceptor {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private _request: HttpRequest<any>;
  constructor(public _authService: BaseAuthService) {}

  private _isGraphCall() {
    return this._request.url.includes(`graph.${HOST_ZONE}`);
  }

  private _graphContainsPatientRequest() {
    if (!this._isGraphCall()) return false;
    const isPatientRequest = this._request.body.query.trim().replace(/\s+/g, "").includes("patient{");
    return isPatientRequest;
  }

  protected shouldGetAuthToken(url: string): boolean {
    if (url.includes("/api/domains/info") || url.includes(AUTH_API_PATH_PREFIX) || url.startsWith("assets/")) {
      return false;
    }

    return true;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    this._request = req;
    const preventCall = (this._authService.isPublicAccess() || this._authService.hasExpired) && this._graphContainsPatientRequest();

    if (preventCall) {
      // If the request is a sensitive graph call and the user is public or has expired JWT, we should not make the API call.
      window.location.href = `${window.location.origin}/`;
      return EMPTY;
    }

    if (!this.shouldGetAuthToken(req.url)) {
      return next.handle(req);
    }

    return this._authService.getAuthToken().pipe(
      switchMap((jwt) => {
        if (jwt) {
          const authReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${jwt}`,
            },
          });

          return next.handle(authReq);
        }

        return next.handle(req);
      })
    );
  }
}
